// useSocket.js
import { useEffect } from 'react';
import { io } from 'socket.io-client';

const socket = io("https://rrooms.in", {
  path: "/rrooms/socket.io",
  transports: ["websocket", "polling"],
  reconnectionAttempts: 5,
  timeout: 10000,
  withCredentials: false,
});
// const socket = io("http://localhost:4000", {https://rrooms.in
//   // path: "/rrooms/socket.io",
//   transports: ["websocket", "polling"],
//   withCredentials: false,
// });

export const useFoodOrderSocket = (propertyId, onNewOrder, onOrderStatusUpdate, onOrderReadyStatusUpdate, onOrderDeliveredStatusUpdate) => {

  useEffect(() => {
    if (!propertyId) return;

    const newOrderEvent = `new-order-${propertyId}`;
    const statusUpdateEvent = `order-accept-reject-${propertyId}`;
    const statusReadyEvent = `order-ready-${propertyId}`;
    const statusDeliveredEvent = `order-delivered-${propertyId}`;

    const handleOrder = (payload) => {
      if (payload?.type === "NEW_ORDER" && payload?.data) {
        onNewOrder(payload);
      }
    };

    const handleStatusUpdate = (payload) => {
      if (payload?.orderId && payload?.status) {
        onOrderStatusUpdate(payload.orderId, payload.status);
      }
    };

    const handleStatusReadyUpdate = (payload) => {
      if (payload?.data) {
        onOrderReadyStatusUpdate(payload);
      }
    };

    const handleStatusDeliveredUpdate = (payload) => {
      if (payload?.data) {
        onOrderDeliveredStatusUpdate(payload);
      }
    };

    socket.on(newOrderEvent, handleOrder);
    socket.on(statusUpdateEvent, handleStatusUpdate);
    socket.on(statusReadyEvent, handleStatusReadyUpdate);
    socket.on(statusDeliveredEvent, handleStatusDeliveredUpdate);

    return () => {
      socket.off(newOrderEvent, handleOrder);
      socket.off(statusUpdateEvent, handleStatusUpdate);
      socket.off(statusReadyEvent, handleStatusReadyUpdate);
      socket.off(statusDeliveredEvent, handleStatusDeliveredUpdate);
    };
  }, [propertyId]);

};

export const socketInstance = socket;
